import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/gal-logo/assets003.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex h-16 p-2 justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-full",
    src: _imports_0
  })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "홈", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "이미지 변환", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "동영상 변환", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "px-2" }, "로그아웃", -1)
const _hoisted_6 = {
  class: "bg-white p-4 shadow-lg overflow-y-auto",
  style: {"height":"calc(100vh - 86px - 48px)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_LoginOutlined = _resolveComponent("LoginOutlined")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { style: {"min-height":"100vh"} }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_sider, {
        collapsed: _ctx.collapsed,
        "onUpdate:collapsed": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.collapsed) = $event)),
        collapsible: ""
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_a_menu, {
            selectedKeys: _ctx.selectedKeys,
            "onUpdate:selectedKeys": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedKeys) = $event)),
            theme: "dark",
            mode: "inline"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_menu_item, {
                key: "home",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onRoute('home')))
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_a_menu_item, {
                key: "images",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onRoute('images')))
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_a_menu_item, {
                key: "videos",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onRoute('videos')))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["selectedKeys"])
        ]),
        _: 1
      }, 8, ["collapsed"]),
      _createVNode(_component_a_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout_header, { style: {"background":"#fff","padding":"0"} }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "flex px-4 justify-end items-center cursor-pointer hover:text-blue-500",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onLogout && _ctx.onLogout(...args)))
              }, [
                _createVNode(_component_LoginOutlined),
                _hoisted_5
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_layout_content, { style: {"margin":"0 16px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_breadcrumb, { style: {"margin":"16px 0"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_breadcrumb_item, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.breadcrumb), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_RouterView)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}